import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { easings } from './motionTokens';

export const FirstVisitEntrance = ({ children }) => {
  const [showSplash, setShowSplash] = useState(false);

  useEffect(() => {
    // Only display on the first visit per session
    const hasVisited = sessionStorage.getItem('pbz_visited_session');
    if (!hasVisited) {
      setShowSplash(true);
      sessionStorage.setItem('pbz_visited_session', 'true');
      const timer = setTimeout(() => {
        setShowSplash(false);
      }, 700);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <>
      <AnimatePresence mode="wait">
        {showSplash && (
          <motion.div
            key="first-visit-splash"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35, ease: easings.exit }}
            className="fixed inset-0 z-[100] bg-[#070C12] flex flex-col items-center justify-center pointer-events-none"
          >
            {/* Logo Mark Fade & Rise */}
            <motion.div
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.35, ease: easings.entrance }}
              className="flex flex-col items-center gap-3"
            >
              <div className="w-12 h-12 rounded-xl border border-[#B99A5B]/40 bg-[#0B1118] flex items-center justify-center shadow-[0_0_30px_rgba(185,154,91,0.25)]">
                <span className="text-[#B99A5B] font-serif font-bold text-xl tracking-wider">P</span>
              </div>
              <span className="text-xs font-serif font-bold uppercase tracking-[0.3em] text-[#F2EEE6]">
                PRIME BUSINESS ZONE
              </span>
            </motion.div>

            {/* Thin gold line draws from center */}
            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 0.45, delay: 0.15, ease: easings.entrance }}
              className="w-32 h-[1px] bg-gradient-to-r from-transparent via-[#B99A5B] to-transparent mt-4"
            />
          </motion.div>
        )}
      </AnimatePresence>
      {children}
    </>
  );
};

export default FirstVisitEntrance;
